module.exports = __webpack_public_path__ + "static/media/injuredPressure.5b7bc268.mp3";